import { useEffect, useState, Dispatch, SetStateAction } from 'react';

interface ChatMessage {
  sources?: {
    search_documents_tool?: unknown[];
    search_messages_tool?: {
      ticket_id: number;
    }[];
  };
  [key: string]: unknown;
}

export const useChatSources = (
  message: ChatMessage | null | undefined,
): [unknown[], Dispatch<SetStateAction<unknown[]>>] => {
  const [sources, setSources] = useState<unknown[]>([]);

  useEffect(() => {
    const allSources: unknown[] = [];

    if (!message || !message.sources) {
      return;
    }

    if (message.sources.search_documents_tool) {
      allSources.push(...message.sources.search_documents_tool);
    }

    if (message.sources.search_messages_tool) {
      const ticketIds = message.sources.search_messages_tool
        .map((source) => {
          return source.ticket_id;
        })
        .filter(Boolean)
        .join(', ');

      ticketIds && allSources.push({ name: `Ticket IDs: ${ticketIds}` });
    }

    setSources(allSources);
  }, [message]);

  return [sources, setSources];
};
